import React from 'react'
import cities from './cities'
import PropTypes from 'prop-types'
import styles from './_cities.css'

function Cities (props) {
  const {
    numberOfColumns = 3,
    margin = '32px auto',
    logEvent,
  } = props
  const cityList = cities.map((city, i) => (
    <City key={`${city.slug}-${i}`} name={city.name} slug={city.slug} logEvent={logEvent} />
  ))
  const columnSize = Math.ceil(cityList.length / numberOfColumns)
  const cityColumns = []
  const citiesStyle = {
    margin,
  }

  while (cityList.length) {
    cityColumns.push(cityList.splice(0, columnSize))
  }

  const cityColumnList = cityColumns.map((column, i) => <ul key={i} className={styles.cityColumn}>{column}</ul>)

  return (
    <div className={styles.cities} style={citiesStyle}>
      {cityColumnList}
    </div>
  )
}

function City (props) {
  const { slug, name, logEvent } = props
  return (
    <li className={styles.city}>
      <a href={slug} onClick={() => logEvent(slug)}>{name}</a>
    </li>
  )
}

City.propTypes = {
  name: PropTypes.string,
  slug: PropTypes.string,
  logEvent: PropTypes.func,
}

Cities.propTypes = {
  numberOfColumns: PropTypes.number,
  margin: PropTypes.string,
  logEvent: PropTypes.func,
}

export default Cities
